import { useSelector } from "react-redux";
import SpinnerLoader from "../../components/SpinnerLoader";
import { RootState } from "../../redux/store";
import { useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

function HomePage() {
  const { message, loading, isAuthorized, userRoles } = useSelector(
    (state: RootState) => state.auth
  );
  const { t } = useTranslation();

  const navigate = useNavigate();

  const getRolesItemsByUserRoles = () => {
    return UserRoleCards.filter((item) => {
      if (item.title === "HR") {
        return userRoles.includes(item.title);
      }

      return userRoles.includes(item.title.toLowerCase());
    });
  };
  useEffect(() => {
    sessionStorage.removeItem("role");
  }, []);

  if (!isAuthorized) {
    return (
      <div className="flex items-center w-full justify-center">
        {!loading && <p>{message}</p>}
        {loading && <SpinnerLoader />}
      </div>
    );
  }

  return (
    <div className="flex flex-col items-start gap-8">
      <Header />
      <div className="w-full flex items-center justify-center">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 place-items-center h-auto w-[40rem]">
          {getRolesItemsByUserRoles().map((role) => (
            <RoleCard key={role.id} role={role} navigate={navigate} />
          ))}
        </div>
      </div>
    </div>
  );
}

export default HomePage;

const UserRoleCards = [
  {
    title: "Learner",
    path: "/learner/available-trainings",
    id: 1,
  },
  {
    title: "Manager",
    path: "/manager",
    id: 2,
  },
  {
    title: "HR",
    path: "/hr/all-trainings",
    id: 3,
  },
  {
    title: "Manager",
    path: "/manager/apply-for-team",
    id: 4,
    subType: "my_team",
  },
  {
    title: "Admin",
    path: "/courses",
    id: 5,
  },
];

// ✅ Extracted RoleCard Component with Hover Effect
const RoleCard = ({ role, navigate }: any) => {
  const [isHovered, setIsHovered] = useState(false);

  // Image mapping based on role
  const imageMapping: any = {
    Manager: {
      default: "/ManagerApprovals_1.svg",
      hover: "/ManagerApprovals_2.svg",
    },
    Learner: {
      default: "/MyTraining_1.svg",
      hover: "/MyTraining_2.svg",
    },
    Admin: {
      default: "/SuperAdmin_1.svg",
      hover: "/SuperAdmin_2.svg",
    },
    HR: {
      default: "/MyHRPage_1.svg",
      hover: "/MyHRPage_2.svg",
    },
  };

  if (role?.subType === "my_team") {
    imageMapping["My Team"] = {
      default: "/MyTeam_1.svg",
      hover: "/MyTeam2.svg",
    };
  }

  return (
    <div
      className="flex items-center justify-center rounded-xl shadow-lg cursor-pointer hover:shadow-xl transition-all duration-300"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={() => {
        navigate(role.path);
        sessionStorage.setItem("role", role.title);
      }}
    >
      <img
        src={
          isHovered
            ? imageMapping[role?.subType === "my_team" ? "My Team" : role.title]
                .hover
            : imageMapping[role?.subType === "my_team" ? "My Team" : role.title]
                .default
        }
        alt={role.title}
        className="w-full h-full object-contain rounded-xl transition-all duration-300"
      />
    </div>
  );
};
